import styles from "../../../styles/components/Modal/Transaction/FilterTransactionModal.module.css"
import React from 'react'

export const FilterTransactionModal = () => {
  return (
    <div>FilterTransactionModal</div>
  )
}
